
if (document.querySelector('.video')) {
    const videos = document.querySelectorAll('.video')
    for (const video of videos) {
        const button = video.querySelector('.overlay button')
        const iframe = video.querySelector('iframe')

        if (button && iframe) {
            button.addEventListener('click', () => {
                button.closest('.overlay').remove()

                iframe.classList.remove('invisible')
                iframe.src = iframe.dataset.src
                iframe.removeAttribute('data-src')
            });
        }
    }
}
